module.exports = __webpack_public_path__ + "static/media/ehealthpro_slider_phone1.f053af98.png";